/**
 * Used to unmask the value based on the masking configuration
 * @param {string}        value
 * @param {MaskingConfig} masking
 */
export const unmaskValue = (value, masking) => {
  if (!value) {
    return '';
  }
  if (!masking?.mask || !masking?.unmask) {
    return value;
  }
  const unmaskRegExp = new RegExp(`[${masking.unmask.join('')}]`, 'g');
  return value.replace(unmaskRegExp, '');
};